import slick from '@accessible360/accessible-slick';

export const Slider = (() => {
	'use strict';

	function init() {
		
		$('[data-slider]').each(function () {
			const $slider = $(this)
			const $slick = $slider.slick({
				draggable: true,
				dots: false,
				arrows: false,
				speed: 500,
				autoplay: true,
				autoplaySpeed: 3000,
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				fade: false,
				cssEase: 'linear',
			});
			$slider.parent().find('[data-slider-prev]').on('click', function () {
				$slick.slick('slickPrev')
			})
			$slider.parent().find('[data-slider-next]').on('click', function () {
				$slick.slick('slickNext')
			})
		})
	}

	return {
		init: init,
		name: 'slider'
	};
})();

